import { Popover } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';
const svc = new ResourceSvc();

export default {
    name: 'dashboardManageRaces',
    props: ['userId'],
    components: {
        [Popover.name]: Popover,
    },
    data() {
        return {
            isProcessing: false,
            errorMessage: null,
            tableData: [],
            years: [],
            selectedYear: 0,
            selectedTypeBySport: null,
            emptyType: 'Without type',
            removeRaceId: null
        };
    },
    computed: {
        racesBySelectedYear() {
            var self = this;
            if (!self.tableData) { return [] }
            var data = self.tableData.filter(x => { return x.year == self.selectedYear; });

            var typeToCheck = self.selectedTypeBySport == self.emptyType ? null : self.selectedTypeBySport;
            if (data && data.length) {
                var result = [];
                data[0].races.forEach(x => { if (x.typeBySport == typeToCheck) { result.push(x); } });
                return result;
            }
            return [];
        },
        typesBySportBySelectedYear() {
            var self = this;
            if (!self.tableData) {
                return []
            }
            var data = self.tableData.filter(x => {
                return x.year == self.selectedYear;
            });
            var result = [];
            if (data && data.length) {
                data[0].races.forEach(x => { result.push(x.typeBySport); });;
                result = result.filter(this.onlyUnique);
            }

            return result;
        },
        domain() {
            return process.env.url.oldApp;
        }
    },
    methods: {
        onlyUnique(value, index, data) {
            return data.indexOf(value) === index;
        },
        getData() {
            var self = this;
            self.isProcessing = true;
            svc.getRacesWhereUserIsOfficer().then(response => {
                var allData = response.body;
                self.isProcessing = false;
                if (!allData) {
                    self.errorMessage = "Something went wrong!";
                    return;
                }
                if (!allData.isSuccess) {
                    self.errorMessage = allData.message;
                    return;
                }
                else {
                    self.errorMessage = null;
                    self.tableData = allData.racesByYears;
                    self.years = allData.years;
                    if (self.years && self.years.length) {
                        self.selectedYear = self.years[0];
                    }
                }
                self.$console();
                self.$console({ races: self.tableData });

                return self.tableData;
            }, () => {
                self.isProcessing = false;
                self.errorMessage = "Something went wrong, please contact with dev team!";
            });
        },
        getColorByRaceStatus(status) {
            var color = 'dimgray !important';
            if (status == "Unpaid") {
                color = '#b2383b !important'
            }
            if (status == "Active") {
                color = '#0f8f52 !important'
            }

            if (status == "Review") {
                color = '#ffa534 !important'
            }
            return { 'color': color };
        },
        changeStatusTo(newStatus, officer) {
            var self = this;
            self.isProcessing = true;
            var officerRequest = {
                raceId: officer.raceId,
                userId: officer.userId,
                newStatus: newStatus,
                officerEnumValue: officer.typeEnumValue
            };
            svc.updateOfficerStatus(officerRequest)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.isSuccess) {
                        officer.isConfirmed = newStatus;
                        self.$showSuccess();
                    }
                    else {
                        self.$showError(response && response.body ? response.body.message : null);
                    }
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError();
                    })
        }
    },
    created() {
        var self = this;
        self.getData();
        EventBus.$emit("user-load-dashboard-card", 0);
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/manage-officer-races/manage-officer-races.js